<template>
  <section :class="$style.recent">
    <h2 :class="[$style.title, 'h3']">Other Partners</h2>

    <div :class="$style.list">
      <transition-group name="fade">
        <BlogSinglePostSkeleton
          v-show="loading !== 'success'"
          v-for="i of 3"
        />
      </transition-group>
      <transition-group name="fade">
        <PartnersSinglePost
          v-show="loading === 'success'"
          v-for="(post, index) of posts"
          :key="index"
          :title="post.title.rendered"
          :image="post.acf?.partners_image || '/images/topPost.webp'"
          :date="post.date"
          :caption="post.excerpt.rendered"
          :_id="post.id"
        />
      </transition-group>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { RepcentPartnersParams } from '.';

const { t } = useI18n();
defineProps<RepcentPartnersParams>();
</script>

<style lang="scss" module>
  .recent {

  }

  .title {
    margin: 0 0 32px 0;
  }

  .list {
    display: flex;
    gap: 32px 24px;

    @media (max-width: 1023px) {
      gap: 18px;

      > *:last-child {
        display: none;
      }
    }

    @media (max-width: 767px) {
      gap: 22px;
      flex-wrap: wrap;
      flex-direction: column;
    }

    > * {
      flex: 1;

      @media (min-width: 768px) {
        max-width: calc(100% / 3 - 22px);
      }
    }
  }
</style>